import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { BffDocumentsService } from '../../shared/services/bff-documents.service';
import { getLocalStorage } from 'src/app/shared/helpers/helper';
import {
  key_user_info,
  statusEnum,
  paths,
} from 'src/app/shared/helpers/constants';
import { DialogMessageModalComponent } from 'src/app/shared/components/dialog-message-modal/dialog-message-modal.component';

import { FormControl, Validators } from '@angular/forms';
import { Observable, Subscriber } from 'rxjs';
import { Router } from '@angular/router';
import { AuthService } from '../../shared/services/auth.service';
import { IUseInfoLocalStorage } from '../../shared/Entities/userInfoLocalStorage';
import { PersonService } from 'src/app/shared/services/person.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'pop-up-firma',
  templateUrl: 'pop-up-firma.html',
  styleUrls: ['pop-up-firma.scss'],
})
export class PopUpFirma implements OnInit {
  public VOF = 0;
  storageUrl = `${environment.url.storage}/documents/Ausad/AUSAD.pdf`;
  userInfo: IUseInfoLocalStorage = getLocalStorage(key_user_info);
  panelOpenState = false;
  loading = false;
  /*All about Email Control */
  EmailInput: string;
  @ViewChild('emailInput') Email!: ElementRef<HTMLInputElement>;

  EmailControl: FormControl = new FormControl('', [
    Validators.required,
    Validators.email,
    Validators.pattern('^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$'),
  ]);

  pdfBase64: string | ArrayBuffer;

  constructor(
    private bffDocumentsService: BffDocumentsService,
    public dialogRef: MatDialogRef<PopUpFirma>,
    public dialog: MatDialog,
    private router: Router,
    private authService: AuthService,
    private personaService: PersonService
  ) {
    dialogRef.disableClose = true;
  }

  ngOnInit() {
    this.userInfo.rut.split('-').join('');
    document.getElementById('main-container').style.width = '600px';
    const _rut = Number(this.userInfo.rut.split('-')[0]);
    const _dv = this.userInfo.rut.split('-')[1];
    this.personaService.GetClientProfile(_rut, _dv).subscribe(
      clienteData => {
        if (clienteData.httpCode === 200) {
          this.EmailControl.setValue(clienteData.client.mail);
        } else {
          this.EmailControl.setValue(this.userInfo.email);
        }
      },
      error => {
        this.EmailControl.setValue(this.userInfo.email);
      }
    );
  }

  public OpenDoc(item) {
    if (item === true) {
      this.VOF = 1;
    }
    if (item === false) {
      this.VOF = 0;
    }
  }

  convertToBase64() {
    this.loading = true;
    const observable = new Observable((subscriber: Subscriber<any>) => {
      this.readFile(subscriber);
    });

    observable.subscribe(data => {
      this.pdfBase64 = data;
      const large = 'data:application/pdf;base64,'.length;
      this.pdfBase64 = this.pdfBase64.slice(
        large,
        this.pdfBase64.toString().length
      );
      this.bffDocumentsService
        .saveDocumentSignature(
          this.userInfo.rut.split('-').join(''),
          this.userInfo.given_name,
          this.userInfo.family_name,
          this.EmailInput.toLowerCase(),
          this.userInfo.lineasnegocios.toUpperCase(),
          this.pdfBase64
        )
        .subscribe(
          res => {
            this.loading = false;
            document.getElementById('Nav1').style.display = 'none';
            document.getElementById('main-container').style.width = '550px';
            document.getElementById('Nav3').style.display = 'block';
          },
          error => {
            this.loading = false;
            this.dialog.open(DialogMessageModalComponent, {
              data: {
                title: 'HA OCURRIDO UN PROBLEMA',
                message: 'Inténtelo más tarde.',
                type: statusEnum.error,
              },
              height: '10.3125rem',
              width: '20.125rem',
            });
          }
        );
    });
  }

  async readFile(subscriber: Subscriber<any>) {
    let blob = null;
    const xhr = new XMLHttpRequest();

    xhr.open('GET', this.storageUrl);
    xhr.responseType = 'blob';
    xhr.onload = () => {
      blob = xhr.response;
      const file2 = new File([blob], 'AUSAD.pdf', {
        type: 'application/pdf',
        lastModified: Date.now(),
      });

      const fileReader = new FileReader();
      fileReader.readAsDataURL(file2);
      fileReader.onload = () => {
        subscriber.next(fileReader.result);
        subscriber.complete();
      };
      fileReader.onerror = error => {
        subscriber.error(error);
        subscriber.complete();
      };
    };
    xhr.send();
  }

  public NAV(option: number) {
    if (option == 0) {
      // Cancelar Acuerdo
      if (!this.loading) {
        document.getElementById('Nav1').style.display = 'none';
        document.getElementById('main-container').style.width = '600px';
        document.getElementById('Nav2').style.display = 'block';
      }
    }
    if (option == 1) {
      this.EmailInput = this.EmailControl.value;
      if (!this.loading && !this.EmailControl.errors) {
        this.convertToBase64();
      }
    }
    if (option == 2) {
      const { lineasnegocios } = this.userInfo;
      const businessLines: string = lineasnegocios;
      this.multiOptions(businessLines.toUpperCase());
    }
    if (option == 3) {
      if (this.VOF == 1) {
        document.getElementById('Nav1').style.display = 'block';
        document.getElementById('main-container').style.width = '600px';
        document.getElementById('Nav2').style.display = 'none';
      }

      if (this.VOF == 0) {
        document.getElementById('Nav1').style.display = 'block';
        document.getElementById('main-container').style.width = '600px';
        document.getElementById('Nav2').style.display = 'none';
      }
    }
    if (option == 4) {
      alert('CerrarPopUp');
    }
  }

  private logout() {
    this.authService.logout().subscribe(data => {});
    this.router.navigate([paths.login.path]);
  }

  private multiOptions(businessLines: string) {
    const lines = businessLines.split(',');
    for (let i = 0; i < lines.length; i++) {
      if (lines[i].includes('INDIVIDUAL') || lines[i].includes('VITALICIAS')) {
        this.logout();
        break;
      }
    }
    this.dialogRef.close();
  }

  public closePopup() {
    this.dialogRef.close();
  }
}
